import { BrowserRouter, Routes, Route } from 'react-router-dom'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import 'react-modern-drawer/dist/index.css'
import NotFound from 'pages/NotFound';
//import ServerError from 'pages/ServerError';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import CreatePlate from 'pages/CreatePlate';
import PrivacyPolicy from 'pages/PrivacyPolicy';
// import StageForgotStep1 from 'components/auth/register/StageForgotStep1';
// import StageForgotStep2 from 'components/auth/register/StageForgotStep2';
// import StageForgotStep3 from 'components/auth/register/StageForgotStep3';
import ExternalAuthGmail from 'components/auth/register/ExternalAuthGmail';
import ExternalAuthFacebook from 'components/auth/register/ExternalAuthFacebook';
import StageForgotStep3 from 'components/auth/register/StageForgotStep3';
import OrderDetail from 'pages/OrderDetail';
import OrderDetailIframe from 'pages/OrderDetailIframe';
import ProtectedRoutes from 'containers/protectedRoute/ProtectedRoutes';
import DeliveryTypeSelection from 'pages/DeliveryTypeSelection';
import Layout from 'containers/layout/Layout';
import Home from 'pages/Home';
import Register from 'pages/Register';
import ProductCategory from 'pages/ProductCategory';
import Detail from 'pages/Detail';
import Payment from 'pages/Payment';
import Address from 'pages/Address';
import Information from 'pages/Information';
import Order from 'pages/Order';

// import Loader from 'pages/Loader';
function App() {
	
	return (
		<BrowserRouter>			
			<ToastContainer position='top-right' autoClose={1000} closeOnClick theme='light' />
				<Routes>
					<Route path='/' element={<Layout />}>

					<Route path='/kayit-ol' index element={<Register />} />
					<Route path='/uye-girisi' index element={<Register />} />
					<Route path='/misafir-girisi' index element={<Register />} />
					
					<Route path='/' element={<ProtectedRoutes isChoiceOptional={true} isAuthRequired={false}/>}>
					<Route index element={<Home />} />
					<Route path='/kendi-tabagini-olustur' index element={<CreatePlate />} />
					<Route path='/kategori/:id' index element={<ProductCategory />} />	
					<Route path='/urun/:id' index element={<Detail />} />
					</Route>	

					<Route path='/' element={<ProtectedRoutes isChoiceOptional={false} isAuthRequired={true} />}>
					<Route path='/odeme' index element={<Payment />} />	
					<Route path='/payment/result' index element={<OrderDetailIframe />} />
					</Route>
					
					<Route path='/' element={<ProtectedRoutes isChoiceOptional={true} isAuthRequired={true}/>}>
					<Route path='/adreslerim' index element={<Address />} />
					<Route path='/hesabim' index element={<Information />} />				
					<Route path='/siparislerim' index element={<Order />} />
					<Route path='/siparis/:id' index element={<OrderDetail />} />
					<Route path='/teslimat-secimi' element={<DeliveryTypeSelection />} />
					</Route>

					<Route path='/hata/:errorStatus' index element={<NotFound />} />
					{/* <Route path='/500' index element={<ServerError />} /> */}
					<Route path='/sayfa/:url' index element={<PrivacyPolicy />} />
					<Route path='/sifremi-unuttum' index element={<StageForgotStep3 />} />
					<Route path='/signin-google' index element={<ExternalAuthGmail />} />
					<Route path='/signin-facebook' index element={<ExternalAuthFacebook />} />
					<Route path='*' index element={<NotFound />} />

					</Route>
				</Routes>
		</BrowserRouter>
	)
}

export default App
